export default __webpack_public_path__ + "static/media/ManagementTonic.2590e4e36dc0cfbe49ca50971eeecd65.webp";